import { Tile } from './../../types';
import { TileActionName } from './../../enums/tile-action';
export class TileActionEvent {
  tile: Tile;
  action: TileActionName;
}
